import axios from "../../config/interceptor";
import { PER_PAGE_SIZE } from "../../utils/constants";

// SOP: CRA calls Next.js proxy → Supabase RPC. axios baseURL
// (REACT_APP_BASE_API_URL) already points to /api/legacy on the
// clinic-next host. Use relative paths so we hit the proxy.

export const getItemOptions = async (businesId) => {
  try {
    const response = await axios.get(`/lambda/v1/get-item-options/${businesId}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const postItem = async (data) => {
  try {
    const response = await axios.post(`/lambda/v1/items`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putItem = async (data) => {
  try {
    const response = await axios.put(`/lambda/v1/items/${data.id}`, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getItems = async ({
  page = 0,
  size = PER_PAGE_SIZE,
  businessId,
  sortKey,
  sortValue,
  search,
  categoryItemId,
  active,
}) => {
  try {
    let link = `/lambda/v1/items/${businessId}?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    if (sortKey) link = link.concat("&sortKey=" + sortKey);
    if (sortValue) link = link.concat("&sortValue=" + sortValue);
    if (search !== undefined && search !== null && search !== "")
      link = link.concat("&search=" + encodeURIComponent(search));
    if (categoryItemId !== undefined && categoryItemId !== null && categoryItemId !== "")
      link = link.concat("&categoryItemId=" + encodeURIComponent(categoryItemId));
    if (active !== undefined && active !== null && active !== "")
      link = link.concat("&active=" + active);

    const response = await axios.get(link);
    return response;
  } catch (error) {
    return error;
  }
};

export const getItemDetail = async (id) => {
  try {
    const response = await axios.get(`/lambda/v1/items/detail/${id}`);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteItem = async (id) => {
  try {
    const response = await axios.delete(`/lambda/v1/items/${id}`);
    return response;
  } catch (error) {
    return error;
  }
};
